import React, { useState, useEffect } from 'react';
import Login from './pages/Login';
import CompleteProfile from './pages/CompleteProfile';
import Dashboard from './pages/Dashboard';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Profile from './pages/Profile';
import Customers from './pages/Customers';

function App() {
  const [currentPage, setCurrentPage] = useState('login');
  
  useEffect(() => {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    
    if (token && user) {
      const userData = JSON.parse(user);
      
      if (!userData.tax_number || !userData.phone) {
        setCurrentPage('complete-profile');
      } else {
        setCurrentPage('dashboard');
      }
    }
  }, []);

  const path = window.location.pathname;
  
  if (path === '/forgot-password') {
    return <ForgotPassword />;
  }
  
  if (path === '/reset-password') {
    return <ResetPassword />;
  }

  if (path === '/profile') {
    const token = localStorage.getItem('token');
    if (!token) {
      window.location.href = '/';
      return null;
    }
    return <Profile />;
  }

  if (path === '/customers') {
    const token = localStorage.getItem('token');
    if (!token) {
      window.location.href = '/';
      return null;
    }
    return <Customers />;
  }

  if (currentPage === 'complete-profile') {
    return <CompleteProfile />;
  }
  
  if (currentPage === 'dashboard') {
    return <Dashboard />;
  }

  return <Login />;
}

export default App;